module.exports = __webpack_public_path__ + "static/img/BR.59c18a07.svg";